module.exports = __webpack_public_path__ + "img/pos_s2_icon1.6056d2b9.png";